/**
 * Created by MateuszWaligora on 14.07.2017.
 */
import Vue from 'vue';
import axios from 'axios';
/**
 * @constant Actions
 * @type {object}

 * */

const state = {
    setupsList: [],
    defaultSetup: {},
    currentSetup: {},
    selections: [],
    currentEnvs: []
};

const mutations = {
    currentSetup: (state, setup) => state.currentSetup = setup,
    defaultSetup: (state, setup) => state.defaultSetup = setup,
    envDefault: (state, data) => {
        state.selections = data.default.selections;
        state.currentEnvs = data.default.menu;
    },
    currentEnvs: (state, envs) => state.currentEnvs = envs
};

const getters = {
    currentSetup: state => state.currentSetup,
    defaultSetup: state => state.defaultSetup,
    currentEnvs: state => state.currentEnvs,
    getEnvMenu: state => state.selections
};

const actions = {
    async GetSetupManagerData ({ commit }) {
        try {
            let { data } = await Vue.axios.get('/setupmanager/data');
            return data;
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to get backup'
            });
            throw new Error(err);
        }
    },
    async GetDefaultSetup ({ commit }) {
        let { data } = await Vue.axios.get('/setupmanager/data/default-config');
        commit('defaultSetup', data);
        return data;
    },
    async GetSetupDataById ({ commit }, id) {
        try {
            let { data } = await Vue.axios.get(`/setupmanager/data/${id}`);
            commit('currentSetup', data);
            return data;
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'Cannot load shop data'
            });
        }
    },
    async GetEnvConfigData ({ commit, dispatch, state }, { context, role }) {
        if(context){
            //const { data } = await axios.get(`http://localhost:1337/envs/${context}?type=${role}`);
            const { data } = await Vue.axios.get(`/configurator/envs/${context}?type=${role}`);
            commit('currentEnvs', data);
        } else {
            await dispatch('GetEnvDefault');
        }
        return state.currentEnvs;
    },
    async GetEnvsBulkConfigData ({ commit, dispatch, state }, { contexts, role = "admin" }) {
        const { data } = await Vue.axios.post(`/configurator/envsbulk?type=${role}`, {contexts});
        return data;
    },
    async GetEnvDefault ({ commit, state }) {
        const { data } = await Vue.axios.get('/configurator/envs');
        commit('envDefault', data);
        return state.currentEnvs;
    },
    async GetBasketData ({}, { Store }) {

        const { data } = await Vue.axios({ method: 'GET', url: '/prices/basket', headers: { Store: Store } });
        return data;
    },
    UpdateCurrentSetup ({ commit }, setup) {
        commit('currentSetup', setup);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
